import { SkeletonProps } from './Skeleton.props';

import './Skeleton.scss';

export const Skeleton = ({ className, height, width }: SkeletonProps) => {
  return (
    <div aria-hidden='true' style={{ height, width }} className={className}>
      <div className='skeleton'></div>
    </div>
  );
};

export default Skeleton;
